import { useState, useCallback, useEffect } from 'react';
import { getPreviousVisitNotes } from 'api/treatment';
import { TPreviousVisitNote } from 'types/treatment';

type Props = {
    clientId?: number;
    excludeBusinessType?: string;
    excludeBusinessId?: number;
    autoFetch?: boolean;
};

const useGetPreviousNotes = (props: Props): [TPreviousVisitNote[], boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TPreviousVisitNote[]>([]);

    const fetchData = useCallback(async () => {
        if (!props.clientId) return;
        try {
            setLoading(true);
            const result = await getPreviousVisitNotes({
                clientId: props.clientId,
                excludeBusinessType: props.excludeBusinessType,
                excludeBusinessId: props.excludeBusinessId,
            });
            if (!result.error) {
                setData(result?.data?.data || []);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [props.clientId, props.excludeBusinessType, props.excludeBusinessId]);

    useEffect(() => {
        if (props.autoFetch) {
            fetchData();
        }
    }, [props.autoFetch, fetchData]);

    return [data, loading, fetchData];
};

export default useGetPreviousNotes;
